import * as React from 'react';
import type { SVGProps } from 'react';
const SvgIconVincere = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='1em'
    height='1em'
    fill='none'
    viewBox='0 0 76 75'
    {...props}
  >
    <path
      fill='#343434'
      d='M24.369 44.257c1.476-4.06 2.952-7.873 4.428-11.809.738-2.091 1.6-4.182 2.337-6.273.37-.984.861-1.845 1.6-2.583 3.935-3.69 8.487-6.028 14.022-5.905 8.61.123 14.638 4.305 18.574 11.809.492.984.861 2.091.492 3.321-.369 1.353-1.599 2.46-2.952 2.583-1.6.123-2.952-.492-3.69-1.845-.123-.246-.246-.615-.37-.86-3.32-8.857-15.006-11.071-21.28-4.183-.368.369-.614.86-.86 1.353-3.076 7.75-6.028 15.622-9.103 23.371-.246.615-.369 1.23-.738 1.722-.861 1.107-1.968 1.6-3.321 1.354q-2.03-.37-2.583-2.215c-1.23-3.32-2.584-6.642-3.814-10.086L8.993 22.608c-.861-2.215.369-4.306 2.583-4.675 1.6-.246 3.075.615 3.69 2.337 1.6 4.06 3.076 8.119 4.675 12.178 1.353 3.69 2.829 7.38 4.182 11.07 0 0 .123.247.246.739'
    />
    <path
      fill='#F05A24'
      d='M47.002 56.323c-4.92 0-9.349-1.476-13.162-4.674-1.599-1.353-1.845-3.321-.615-4.92 1.23-1.476 3.322-1.722 4.92-.37 1.846 1.6 3.814 2.83 6.274 3.199a12.74 12.74 0 0 0 14.76-9.84c.37-1.846 1.969-3.076 3.937-2.953 1.722.123 3.321 1.722 3.321 3.444 0 .984-.369 1.969-.615 2.953-2.46 7.011-7.503 11.07-14.638 12.67-1.353.368-2.829.368-4.182.491'
    />
  </svg>
);
export default SvgIconVincere;
